import { render } from "./SpaTreatmentPayment.vue?vue&type=template&id=68f99ce5"
import script from "./SpaTreatmentPayment.vue?vue&type=script&lang=js"
export * from "./SpaTreatmentPayment.vue?vue&type=script&lang=js"

import "@/shared/css/payment.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__